import classNames from "classnames"
import { Outlet } from "react-router-dom"

type Props = React.HTMLAttributes<HTMLDivElement>

export const AdminGuestsLayout: React.FC<Props> = () => {
  return (
    <div
      className={classNames(
        "mt-20 flex flex-grow justify-center admin-scrollable-block",
        "overflow-auto",
        "pt-4 px-4 lg:px-10 xl:px-24 2xl:px-36 sm:pb-4",
      )}
      style={{
        scrollbarWidth: "auto",
      }}
    >
      <Outlet />
    </div>
  )
}
